import { forwardRef } from 'react';
import flaerLogo from '@/assets/flaer-logo.png';
import { cn } from '@/lib/utils';

interface FlaerLogoProps {
  size?: 'xs' | 'sm' | 'md' | 'lg' | 'xl' | '2xl' | '3xl';
  className?: string;
  showText?: boolean;
  textClassName?: string;
  inverted?: boolean;
}

const sizeMap = {
  xs: 'w-10 h-10',
  sm: 'w-14 h-14',
  md: 'w-20 h-20',
  lg: 'w-24 h-24',
  xl: 'w-28 h-28',
  '2xl': 'w-36 h-36',
  '3xl': 'w-48 h-48',
};

const textSizeMap = {
  xs: 'text-xl',
  sm: 'text-2xl',
  md: 'text-3xl',
  lg: 'text-4xl',
  xl: 'text-5xl',
  '2xl': 'text-6xl',
  '3xl': 'text-7xl',
};

export const FlaerLogo = forwardRef<HTMLDivElement, FlaerLogoProps>(({ 
  size = 'md', 
  className,
  showText = false,
  textClassName,
  inverted = true
}, ref) => {
  return (
    <div ref={ref} className={cn('flex items-center gap-3', className)}>
      <img 
        src={flaerLogo} 
        alt="FLAER" 
        className={cn(
          sizeMap[size], 
          'object-contain',
          inverted && '[filter:brightness(0)_invert(1)]'
        )}
      />
      {showText && (
        <span className={cn(
          'font-bold tracking-tight text-foreground',
          textSizeMap[size],
          textClassName
        )}>
          FLAER
        </span>
      )}
    </div>
  );
});

FlaerLogo.displayName = 'FlaerLogo';

export default FlaerLogo;
